import MainNav from "../components/mainNav";
import SideNavBody from "../components/sideNavBody";

const ComingSoon = ({title}) => {
    return ( 
        <main>
            <MainNav />
            <SideNavBody title={title}/>
        </main>
     );
}
 
export default ComingSoon;